import { createCrudHooks } from './use-crud-factory'
import type { SupabaseQueryChain } from '@/types/supabase-helpers'
import type { Service } from '@/types/database.types'

/* ============================================================
   useServices — PRD §8.3
   CRUD for service records.
   ============================================================ */

const {
  useList: useServiceList,
  useOne: useService,
  useCreate: useCreateService,
  useUpdate: useUpdateService,
  useDelete: useDeleteService,
} = createCrudHooks<Service>({
  table: 'services',
  queryKey: 'services',
  orderBy: 'name',
  orderAsc: true,
  defaultFilter: (q: SupabaseQueryChain) => q.eq('is_active', true),
})

export {
  useServiceList,
  useService,
  useCreateService,
  useUpdateService,
  useDeleteService,
}

export { useServiceList as useServices }
